import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material'
import { Navigate } from 'react-router-dom'
import { useAuthRedirect } from '@/components/AuthButtons'
import { Authenticated, Unauthenticated } from '@/utils/auth/auth'
import { usePageTitle } from '@/utils/hooks/usePageTitle'
import { useFocusManagement } from '@/utils/hooks/useFocusManagement'
import { useAuth0 } from '@/utils/auth/auth0'
import Loading from '@/components/Loading'

export default function SignupPage() {
  usePageTitle('Sign up')

  const { isLoading } = useAuth0()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { signup } = useAuthRedirect()
  const focusRef = useFocusManagement()

  // Auth0's isAuthenticated defaults to false while the SDK initialises, so
  // without this gate an authenticated user would briefly see the signup page
  // before <Authenticated> redirects them home.
  if (isLoading) {
    return <Loading />
  }

  return (
    <>
      <Unauthenticated>
        <Box
          component="main"
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            width: isMobile ? '100%' : '50%',
            margin: '0 auto',
            height: '80vh',
            textAlign: 'center',
            px: isMobile ? 2 : 0,
          }}
        >
          <img
            src="/Fundsorter-h-black800px.png"
            alt="Fundsorter"
            width={isMobile ? '70%' : '50%'}
          />

          <Typography
            variant="h5"
            component="h1"
            ref={focusRef}
            tabIndex={-1}
            sx={{ mt: 4, color: '#1C3045', '&:focus': { outline: 'none' } }}
          >
            Welcome to Fundsorter!
          </Typography>

          <Typography sx={{ mt: 2, maxWidth: 480, color: '#1C3045' }}>
            You're just a few clicks away from finding funding that's a great
            fit for your organisation.
          </Typography>
          <Typography sx={{ mt: 2, maxWidth: 480, color: '#1C3045' }}>
            Click the button below to create your account and get started. We
            may ask you to quickly verify your email along the way.
          </Typography>

          <Button
            disableRipple
            variant="contained"
            onClick={signup}
            sx={{
              borderRadius: 3,
              bgcolor: '#1C3045',
              color: 'white',
              mt: 4,
              width: isMobile ? '80%' : '50%',
              maxWidth: 450,
              fontSize: '22px',
              textTransform: 'none',
            }}
          >
            Sign up
          </Button>
        </Box>
      </Unauthenticated>
      <Authenticated>
        <Navigate to="/" replace />
      </Authenticated>
    </>
  )
}
